export const ITEMS_PER_ROW = 10;

export const DEFAULT_KEYBOARD = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
